export default "__VITE_ASSET__CmvMmN8Y__"